export default function handlePermissionDeniedListError<T>(
  data: T[] | undefined,
  error: Error | undefined,
): {items: T[]; error: Error | undefined} {
  if (!error) {
    return {
      items: data ?? [],
      error: undefined,
    };
  }

  const message = (error as {message?: string}).message;
  const code = (error as {code?: string}).code;

  const isPermissionDeniedListError =
    code === 'permission-denied' || (typeof message === 'string' && message.includes("false for 'list'"));

  if (isPermissionDeniedListError) {
    return {
      items: [],
      error: undefined,
    };
  }

  return {
    items: data ?? [],
    error,
  };
}
